import React from 'react';
import Input from '@/components/styled/Input';

interface ValidatedInputProps extends Omit<React.ComponentProps<typeof Input>, 'onChange'> {
    value: string;
    error: string;
    onChange: (value: string) => void;
    wrapperClassName?: string;
    errorClassName?: string;
}

export const ValidatedInput: React.FC<ValidatedInputProps> = ({
    value,
    error,
    onChange,
    wrapperClassName = 'w-full',
    errorClassName = 'text-red-500 text-sm mt-1',
    ...inputProps
}) => {
    return (
        <div className={wrapperClassName}>
            <div className={error ? 'border border-red-500 rounded' : ''}>
                <Input {...inputProps} value={value} onChange={(e) => onChange(e.target.value)} />
            </div>
            {error && <div className={errorClassName}>{error}</div>}
        </div>
    );
};
